import React from "react";
import Application, { mountComponent, openDialog, closeDialog } from "./Application";
import print from "./Print";

document.addEventListener('DOMContentLoaded', () => {
    mountComponent('root', Application);
    mountComponent('download', Download);
});
const Download = ({
    title = "document"
}) => {
    const handleClick = () => {
        openDialog(
            "email",
            {
                    onSuccess: () => {
                        print(title);
                        closeDialog();
                    }
            }, // Props to pass to the Email component
            "Suscripción para PDF", // Dialog title
            "medium" // Dialog size
        );
    };

    return (
        <button
            onClick={handleClick}
            type="button"
        >
            Descargar PDF
        </button>
    );
};

export default Download;